import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet';
import {Route, RouteComponentProps, Switch} from 'react-router-dom';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import {SurveySlugProvider} from 'client/common/contexts/slug';
import {useUser} from 'client/common/contexts/user';
import Header, {headerMeaningfulSelector} from 'client/common/components/header2';
import Footer from 'client/common/components/footer';
import {ErrorBoundary} from 'client/common/components/error';
import Notifications from 'client/common/components/notifications/notifications';
import {Chat} from 'client/common/components/chat';
import {useRumCounter} from 'client/common/utils/rum';

import CreativeList from 'client/creatives/components/creative-list';
import CreativeSettings from 'client/creatives/components/creative-settings';

import './creatives.css';

const i18n = I18N.creatives;
const b = b_.with('creatives');

interface SettingsPageParams {
    slug: string;
}

export default function Creatives() {
    const user = useUser();
    const experiments = user?.experiments ?? {};

    useRumCounter({
        page: 'quicksurvey.creatives',
        meaningfulPaintSelector: headerMeaningfulSelector,
        testBuckets: user?.testBuckets ?? []
    });

    return (
        <Fragment>
            <Helmet>
                <title>{i18n.pageTitle}</title>
            </Helmet>
            <Switch>
                <Route path={['/creatives', '/creative/:slug']}>
                    <Header
                        className={b('header')}
                        buttons={['help', 'wallet', 'create', 'dialog']}
                        boxType='creative'
                    />
                </Route>
                <Route path={['/bordomatiks', '/bordomatik/:slug']}>
                    <Header
                        className={b('header')}
                        buttons={['help', 'wallet', 'create', 'dialog']}
                        boxType='bordomatik'
                    />
                </Route>
            </Switch>
            <div className={b('container')}>
                <div className={b()}>
                    <ErrorBoundary position='center'>
                        <Switch>
                            <Route
                                exact
                                path='/creatives'
                                component={() => (
                                    <CreativeList boxType='creative' experiments={experiments} />
                                )}
                            />
                            <Route
                                path='/creative/:slug'
                                component={(props: RouteComponentProps<SettingsPageParams>) => (
                                    <SurveySlugProvider value={props.match.params.slug}>
                                        <CreativeSettings />
                                    </SurveySlugProvider>
                                )}
                            />
                            <Route
                                exact
                                path='/bordomatiks'
                                component={() => (
                                    <CreativeList boxType='bordomatik' experiments={experiments} />
                                )}
                            />
                            <Route
                                path='/bordomatik/:slug'
                                component={(props: RouteComponentProps<SettingsPageParams>) => (
                                    <SurveySlugProvider value={props.match.params.slug}>
                                        <CreativeSettings />
                                    </SurveySlugProvider>
                                )}
                            />
                        </Switch>
                    </ErrorBoundary>
                </div>
                <Footer />
            </div>
            <Notifications />
            <Chat experiments={experiments} from='creatives' />
        </Fragment>
    );
}
